<template>
    <div class="generatedHTML__wrapper">
     <pre style="overflow: scroll;">
        <div id="output">{{popUpOutput}}</div>
    </pre>

    <button class="copyCTA" @click="handleCopy">Copy</button>
    <p v-show="copied" class="helpermsg">Copied to clipboard!</p>
    </div>
</template>

<script setup>
import {popUpOutput} from '@/helper/helper'
import { ref } from 'vue';

  const copied = ref(false)

  const handleCopy = () => {
    var copyText = document.getElementById("output");

    navigator.clipboard.writeText(copyText.innerText);

    copied.value = true

    setTimeout(() => {
        copied.value = false
    }, 1000)
  }
</script>

<style>

</style>